import Comp from './comp'
import Desc from './desc'
import Preview from './preview'

const Plugin = {
    name: '热区手风琴',  // 组件的名称
    render: Comp,      // 要展示在画布中的UI
    board: Desc,       // 要展示在配置项中的UI
    preview: Preview,  // 要展示在预览页面中的UI
    subPlugins: [],    // 子组件，子组件可以理解为一个组件的内部组件，除了没有name和type外，其余的配置和父组件一致
    type: 'hot-accordion',   // 类型，也相当于组件的唯一标识，不要和其他组件的type重名
    props: {
        banners: [{
            imageUrl: '//img11.360buyimg.com/zx/jfs/t1/150215/14/12307/357569/5f97d057E15ad2443/71f7786c12e34d2f.png',
            jumpUrl: '',
        }, {
            imageUrl: '//img20.360buyimg.com/zx/jfs/t1/143055/33/12295/330862/5f97d057Eb7729206/fbe3afb5f4525e82.png',
            jumpUrl: '',
        }, {
            imageUrl: '//img14.360buyimg.com/zx/jfs/t1/148418/4/12395/359908/5f97d057Ec81b9976/be911b46f1f372a6.png',
            jumpUrl: '',
        }],
        bannerWidth: 300,
        between: 25,
        interval: 3,
    },
    extension: {
        struct: {
            imageUrl: '',
            jumpUrl: '',
        },
        scrollWidthDuration: [0, 1125],
        intervalDuration: [1, 10]
    },
    rectOptions: {
        width: 375,
        height: 341,
        left: 0,
        top: 0,
        rotate: 0,
        subRectOptions: []
    },
    drawOptions: {
        resize: true,
        drag: true,
        rotate: false,
        keepRatio: true,
        subOptions: []
    },
}

export default Plugin